require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_core-js@2.6.2@core-js/library/modules/es7.symbol.async-iterator.js
// module id = 472
// module chunks = 0